<template>
  <div class="BlockList" v-show="floag">
    <div class="BlockList-W">
      <img
        class="imgs"
        src="../../../assets/pc/Login/close.png"
        @click="close"
      />
      <div class="logintit">Sign in</div>
      <div class="loginbox">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="putext">
            <el-form-item prop="email">
              <el-input
                v-model="form.email"
                class="inpttext"
                placeholder="Email"
              ></el-input>
            </el-form-item>
          </div>

          <div class="putext">
            <el-form-item prop="password">
              <el-input
                v-model="form.password"
                type="password"
                show-password
                class="inpttext"
                placeholder="Password"
              ></el-input>
            </el-form-item>
          </div>
          <div class="forgot" @click="forgot">Forgot password?</div>
          <div class="logins" @click="login">OK</div>
          <div class="signup" @click="signup">Sign Up</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { GetLogin } from "@/assets/server/api";
import { getSubStr } from "@/utils/utils";
export default {
  props: ["flog", "flogb"],
  data() {
    return {
      floag: false,
      floagb: false,
      xprlAddress:"",
      donationAddress:"",
      coinType:"",
      form: {
        email: "",
        password: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {},
  watch: {
    deep: true,
    flog(val) {
      this.floag = val;
    },
    flogb(val) {
     // console.log(val);
      this.floagb = val;
    },
  },
  methods: {
    close() {
      this.floag = false;
      this.$emit("loginflog", this.floag);
    },
    forgot(){
      this.floag = true;
      this.$emit("loginflog", this.floag);
      this.$emit("fflog", true)
    },
    signup() {
      // this.floag = false;
      this.floagb = true;
      // this.$emit("loginflog", this.floag);
      this.$emit("signups", this.floagb);
    },
    //点击进行账号登录
    async login() {
      // let config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //     jwtToken: this.jwtToken,
      //   },
      // };
      this.$refs.form.validate(async (success) => {
        //    if (this.validatePassword()) {
        //    console.log(this.form);
        if (success) {
          const params = {
            email: this.form.email,
            password: this.form.password,
          };
          const formData = new FormData();
          const item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await GetLogin(formData);
         // let data = await GetLogin(formData, config);
         // console.log(data);
          if (data.code == 200) {
          //  console.log("登录成功");
            this.floag = false;
            this.$router.push("/Index");
            this.$message("Login successful");
            this.$emit("email", getSubStr(this.form.email, 0, 4));
            this.$emit("isBind", data.result.isBindAddress);
            if(data.result.addressBind !==null){
            this.xprlAddress= data.result.addressBind.address;
         //   console.log(this.xprlAddress);
            this.donationAddress=data.result.addressBind.donationAddress;
            this.coinType=data.result.addressBind.coinType;
          //  console.log(this.donationAddress);
            // localStorage.setItem("isBindAddress", 1);
            this.$emit("xprl", this.xprlAddress);
            this.$emit("donation", this.donationAddress);
            this.$emit("coinTypes", this.coinType);
            }
         
            // this.flog = false;
            localStorage.setItem("userId", data.result.userId);
            localStorage.setItem("email", data.result.email);
            localStorage.setItem("jwtToken", data.result.jwtToken);
            localStorage.setItem("isBindAddress", data.result.isBindAddress);
            if(data.result.addressBind !==null){
            localStorage.setItem("xprl",this.xprlAddress);
            localStorage.setItem("donation", this.donationAddress);
            }
        

            // this.$emit("emails", data.result.email);
            // this.$router.push("/m/Ownership");
            // this.$router.push({
            //   path: "/m/Ownership",
            //   query: { userId: data.result.userId },
            // });
            // this.flog1 = true;
            // this.flog = false;
            // this.emails = data.result;
          } else {
            // this.$message(data.result);
            this.$message({
              message: data.result,
              type: "warning",
              customClass: "message-zindex",
            });
          }
        } else {
          // this.$message(" This field are not filled in ");
          this.$message({
            message: "This field are not filled in",
            type: "warning",
            customClass: "message-zindex",
          });
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999999;
  // background: red;
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 365px;
    height: 355px;
    background: #151515;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    position: absolute;
    z-index: 0 !important;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .imgs {
      width: 18px;
      height: 18px;
      margin-left: 335px;
      margin-top: 12px;
    }
    .logintit {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 22px;
      color: #ffffff;
      line-height: 33px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 10px;
    }
    .loginbox {
      width: 305px;
      margin: 0 auto;
      margin-top: 36px;
      .putext {
        /deep/.el-input__inner {
          border: none;
          background: #151515;
          border-bottom: 1px solid #5b5b5b;
          padding-bottom: 10px;
          padding-left: 0px;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 16px;
          color: #fff;
          padding-left: 12px;
        }
        /deep/.el-input__inner::placeholder {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.3);
        }
      }
      .forgot {
        height: 21px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 21px;
        margin-top: -20px;
        margin-left: 180px;
        cursor: pointer;
      }
      .logins {
        width: 305px;
        height: 38px;
        background: #3cf6f0;
        border-radius: 81px 81px 81px 81px;
        text-align: center;
        line-height: 38px;
        margin-top: 38px;
        cursor: pointer;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 15px;
        color: #151515;
      }
      .signup {
        text-align: center;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
